import React, { useState } from 'react';
import { QaRubric } from '../components/qa/QaRubric';
import { useDataStore } from '../context/DataStoreContext';
export function Qa() {
  const {
    leads,
    qaRecords
  } = useDataStore();
  const [selectedLeadId, setSelectedLeadId] = useState<string | null>(leads.length > 0 ? leads[0].id : null);
  const selectedLead = leads.find(l => l.id === selectedLeadId);
  return <div className="p-4 md:p-8 max-w-[1100px] mx-auto space-y-6 pb-24 md:pb-8" data-id="element-1062">
      <div className="flex items-center justify-between" data-id="element-1063">
        <div data-id="element-1064">
          <h1 className="text-[28px] font-bold text-growthly-text" data-id="element-1065">
            Quality Assurance
          </h1>
          <p className="text-[13px] text-growthly-muted mt-1" data-id="element-1066">
            Auditoría de llamadas y mensajes.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1067">
        <div className="lg:col-span-1" data-id="element-1068">
          <div className="card overflow-hidden" data-id="element-1069">
            <div className="p-4 border-b border-white/5 bg-growthly-panel" data-id="element-1070">
              <h3 className="text-[14px] font-semibold text-growthly-text" data-id="element-1071">
                Leads para Revisión
              </h3>
            </div>
            <div className="divide-y divide-white/5 max-h-[600px] overflow-y-auto custom-scrollbar" data-id="element-1072">
              {leads.length === 0 ? <div className="p-6 text-center text-growthly-muted text-[13px]" data-id="element-1073">
                  No hay leads disponibles para QA.
                </div> : leads.map(lead => {
              const hasQa = qaRecords.some(q => q.leadId === lead.id);
              return <div key={lead.id} onClick={() => setSelectedLeadId(lead.id)} className={`p-4 cursor-pointer transition-colors ${selectedLeadId === lead.id ? 'bg-white/5 border-l-2 border-l-growthly-amber' : 'hover:bg-white/[0.02]'}`} data-id="element-1074">
                      <div className="flex justify-between items-start mb-1" data-id="element-1075">
                        <span className="text-[14px] font-medium text-growthly-text" data-id="element-1076">
                          {lead.NOMBRE_NEGOCIO}
                        </span>
                        <span className="text-[11px] text-growthly-muted" data-id="element-1077">
                          {new Date(lead.CREATED_AT).toLocaleDateString()}
                        </span>
                      </div>
                      <div className="flex justify-between items-center text-[12px]" data-id="element-1078">
                        <span className="text-growthly-muted" data-id="element-1079">Ivana J.</span>
                        {hasQa ? <span className="bg-growthly-green/10 text-growthly-green px-2 py-0.5 rounded" data-id="element-1080">
                            Evaluado
                          </span> : <span className="bg-white/10 px-2 py-0.5 rounded text-growthly-text" data-id="element-1081">
                            Pendiente
                          </span>}
                      </div>
                    </div>;
            })}
            </div>
          </div>
        </div>

        <div className="lg:col-span-2" data-id="element-1082">
          {selectedLead ? <QaRubric leadId={selectedLead.id} leadName={selectedLead.NOMBRE_NEGOCIO} setterName="Ivana Jovanoska Risteska" data-id="element-1083" /> : <div className="card p-12 flex items-center justify-center text-growthly-muted text-[14px] border-dashed border-white/10" data-id="element-1084">
              Selecciona un lead de la lista para evaluar.
            </div>}
        </div>
      </div>
    </div>;
}